import {storageFunctions} from "../../storage";
import * as Navigation from "../../refrences/RootNavigation";
import {removePushSubscription} from "../../src/pushScripts";

export default function LogoutPressable(props: { viewClass: any } & { [key: string]: any }) {
    return <props.viewClass title="خروج از حساب کاربری" onPress={() => {
        removePushSubscription().then(() => {
            storageFunctions.deleteData("api_key").then(() => {
                Navigation.replace("Login");
            });
        }).catch(() => {
            storageFunctions.deleteData("api_key").then(() => {
                Navigation.replace("Login");
            });
        });
    }} {...props}/>
}